import { Box, SimpleGrid, Text, Select, HStack, Flex } from "@chakra-ui/react";
import { Device } from "../components/Device.jsx";
import { PumpDeviceFull } from "../components/PumpDeviceFull.jsx";
import { SaltPumpDeviceFull } from "../components/SaltPumpDeviceFull.jsx";
import { PumpDeviceFullRT } from "../components/PumpDeviceFullRT.jsx";
import { SaltPumpDeviceFullRT } from "../components/SaltPumpDeviceFullRT.jsx";
import { useLoaderData, redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useState, useContext, useEffect } from "react";
import { SignalRContext } from "./SignalRContext.jsx";
import { getAnalytics, logEvent } from "firebase/analytics";
import axios from "axios";

function getCurrentBlockDevices(devices, block, type) {
    return devices.filter((device) => device.block === block && device.deviceType === type);
}

export const BlocksNew = () => {
    const { message } = useContext(SignalRContext);
    const { t } = useTranslation();
    const devicesFromApi = useLoaderData();

    const [blocks, setBlocks] = useState([]);
    const [selectedBlock, setSelectedBlock] = useState("1");
    const [allDevices, setAllDevices] = useState([]);
    const [allPumps, setAllPumps] = useState([]);
    const [allRTopPumps, setAllRTopPumps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(domain + "/buildinginfo/getAllBlocks")
            .then((res) => res.json())
            .then((data) => setBlocks(data));
    }, []);

    const fetchAndCombineData = async () => {
        try {
            const httpClient1 = axios.create({
                baseURL: 'https://villarhapsodyiot.org',
                headers: { 'Content-Type': 'application/json' }
            });

            const httpClient2 = axios.create({
                baseURL: 'https://villarhapsodyiot.org',
                headers: { 'Content-Type': 'application/json' }
            });

            const [devicesResponse, detailsResponse] = await Promise.all([
                httpClient1.get('/Devices/GetDevicesOnAllBlocks'),
                httpClient2.get('/Devices/GetManagementBlocks')
            ]);

            const devices = devicesResponse.data;
            const details = detailsResponse.data;

            // Store all devices
            setAllDevices(devices);

            // Store all pumps and rtoppumps
            const pumps = devices.filter(d => d.deviceType === 2);
            const rtoppumps = devices.filter(d => d.deviceType === 3);
            setAllPumps(pumps);
            setAllRTopPumps(rtoppumps);

            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    // Initial load
    useEffect(() => {
        fetchAndCombineData();
    }, []);

    // Handle SignalR updates
    useEffect(() => {
        if (message && message.flag === true) {
            const updatedDevices = Array.isArray(message.devices) ? message.devices : [];

            // Update all devices with new data from SignalR
            setAllDevices(prevDevices => {
                return prevDevices.map(device => {
                    const updatedDevice = updatedDevices.find(d => d.deviceId === device.deviceId);
                    return updatedDevice ? { ...device, ...updatedDevice } : device;
                });
            });

            // Update pumps with new data from SignalR
            setAllPumps(prevPumps => {
                return prevPumps.map(pump => {
                    const updatedPump = updatedDevices.find(d => d.deviceId === pump.deviceId && d.deviceType === 2);
                    return updatedPump ? { ...pump, ...updatedPump } : pump;
                });
            });

            // Update rtoppumps with new data from SignalR
            setAllRTopPumps(prevRTopPumps => {
                return prevRTopPumps.map(pump => {
                    const updatedPump = updatedDevices.find(d => d.deviceId === pump.deviceId && d.deviceType === 3);
                    return updatedPump ? { ...pump, ...updatedPump } : pump;
                });
            });
        }
    }, [message]);

    const handleChange = (e) => {
        setSelectedBlock(e.target.value);
    };

    // Filter devices for the current selected block
    const currentBlockDevices = allDevices.filter(d => d.deviceType === 1 && d.block === selectedBlock);
    const currentPumps = allPumps.filter(pump => pump.block === selectedBlock && pump.deviceType === 2);
    const currentRTopPumps = allRTopPumps.filter(pump => pump.block === selectedBlock && pump.deviceType === 3);

    return (
        <>
            <Flex justify="space-between" align="flex-start" mt="20px" ml="20px" mr="20px" gap="20px">
                <Box flex="1">
                    {/* First row for pumpsData */}
                    <SimpleGrid columns={2} spacing="20px" mb="20px">
                        <PumpDeviceFull pumps={currentPumps} />
                        <SaltPumpDeviceFull pumps={currentPumps} />
                    </SimpleGrid>

                    {/* Second row for rtoppumpsData */}
                    <SimpleGrid columns={2} spacing="20px">
                        <PumpDeviceFullRT pumps={currentRTopPumps} />
                        <SaltPumpDeviceFullRT pumps={currentRTopPumps} />
                    </SimpleGrid>
                </Box>

                <Box>
                    <Select
                        size="sm"
                        placeholder={t("text_select_floor")}
                        onChange={handleChange}
                        value={selectedBlock}
                    >
                        {blocks.map((block) => (
                            <option key={block.buildingInfoId} value={block.block}>
                                {block.description}
                            </option>
                        ))}
                    </Select>
                </Box>
            </Flex>
        </>
    );
};

const domain = process.env.REACT_APP_API_SERVER_URL;
const accessToken = sessionStorage.getItem("accessToken");

const requestOptions = {
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
};

const getDeviceOnAllBlocks = domain + "/Devices/getDevicesOnAllBlocks";
export const blockDataLoader = async () => {
    const analytics = getAnalytics();
    console.log("loader %s", getDeviceOnAllBlocks);
    const res = await fetch(getDeviceOnAllBlocks, requestOptions);
    if (res.ok) {
        const result = await res.json();
        return result;
    } else {
        console.log("Fetch error %s return %d", getDeviceOnAllBlocks, res.status);
        logEvent(analytics, "error", { status_code: res.status });
        if (res.status === 401) {
            return redirect("/login");
        } else {
            throw new Response("", { status: res.status });
        }
    }
};